import {
    GET_ALL_CURRENCIES
} from './constants';

const initialState = {
    allCurrencies: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_CURRENCIES: {
            return {
                ...state,
                allCurrencies: action.payload,
            };
        }
        default:
            return state;
    }
};

